import { motion, useReducedMotion } from "framer-motion";
import { Section, Headline, Reveal, Field } from "@/components/primitives";
import { terms } from "@/config";
import { stagger, item, viewport } from "@/lib/motion";

export default function Terms() {
  const reduce = useReducedMotion();
  return (
    <Section id="terms" tone="charcoal">
      <Reveal className="mx-auto max-w-3xl">
        <p className="text-sm text-cream/70">
          {terms.preline} <span className="ml-2 font-mono text-[0.62rem] tracking-wider text-gray2/70">{terms.attribution}</span>
        </p>
        <Headline className="mt-4">{terms.headline}</Headline>
      </Reveal>

      <motion.dl
        variants={reduce ? undefined : stagger(0.1)} initial={reduce ? false : "hidden"} whileInView="show" viewport={viewport}
        className="card mx-auto mt-12 max-w-3xl divide-y divide-cream/8 rounded-2xl px-6 sm:px-8"
      >
        {terms.fields.map((f) => (
          <motion.div key={f.label} variants={item} data-testid="terms-field" className="grid grid-cols-1 gap-1 py-5 sm:grid-cols-[180px_1fr] sm:gap-6">
            <dt className="label pt-1">{f.label}</dt>
            <dd className="relative text-base text-cream/90">
              <Field value={f.value} />
              <span className="mt-2 block h-px w-full bg-gradient-to-r from-gold/40 to-transparent" />
            </dd>
          </motion.div>
        ))}
      </motion.dl>
    </Section>
  );
}
